import type { Cfg, State } from './types';

export const DEFAULT_CFG: Cfg = {
  rate: 3,
  targetHome: 2,
  targetSchool: 2,
  base: 20,
  baseAfterDebt: 40,
  debtTotal: 200,
  debtWeekly: 20,
  debtStart: '2026-09-12',
  schoolDays: [0, 1, 2, 3, 4],
};

export const emptyState = (): State => ({ days: {}, cfg: { ...DEFAULT_CFG }, ledger: [], outings: [], rev: 0 });
